export class AdminSearchItem {
    AdminSearchID: number;
    SearchLabel: string;
}

export class AdminSearchItemArray extends Array<AdminSearchItem> {

    constructor(...items: AdminSearchItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminSearchItemArray.prototype);
    }
}
